module.exports = __webpack_public_path__ + "static/img/guidance2.917fa3bd.webp";